import { css } from '@microsoft/fast-element';

export const genericCardStyling = css`
  zero-card {
    border-radius: 6px;
    border: 1px solid var(--border-1);
    background-color: var(--neutral-layer-3);
    box-shadow: 0 0 15px 0 rgb(0 0 0 / 35%);
    padding-left: 10px;
    padding-right: 10px;
  }

  zero-card.no-padding-card {
    padding: 0;
  }
`;
